import { MAINTENANCE_NOTICE_ID } from "../utils/maintenance";

export default function MaintenanceNotice() {
  return (
    <div className="bg-[#F3F3F3] px-2 py-4 md:flex md:justify-center">
      <section
        id={MAINTENANCE_NOTICE_ID}
        aria-labelledby={`${MAINTENANCE_NOTICE_ID}-title`}
        className="flex flex-col gap-2 w-full bg-white pt-3 pb-4 px-2 md:px-[28px] rounded-md shadow-[0_0_10px_rgba(0,0,0,0.05)] md:max-w-[680px]"
      >
        <h2
          id={`${MAINTENANCE_NOTICE_ID}-title`}
          className="text-[18.5px] font-semibold text-center text-[#FF4B00]"
        >
          メンテナンス中です
        </h2>
        <p className="text-[15px] leading-relaxed">
          キャラつくAIは現在メンテナンス中のため、新しいキャラクターの生成受付を一時停止しています。
        </p>
        <p className="text-[15px] leading-relaxed">
          すでに生成済みのキャラクター画像は、メールでお届けしたページから引き続きご覧いただけます。
        </p>
        <p className="text-[13px] text-[#666666]">
          ご不便をおかけして申し訳ございません。
        </p>
      </section>
    </div>
  );
}
